import { StepLabel as MuiStepLabel } from '@mui/material'
import React from 'react'

import { StepLabelProps } from './stepper.types'

export const StepLabel: React.FC<StepLabelProps> = ({ children, ...rest }) => {
  return <MuiStepLabel {...rest}>{children}</MuiStepLabel>
}
